import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { getDateStringFromTimestamp } from '../../helper';
import Banner from '../Banner';
import classes from './style.module.scss';

const Buyer = ({ displayName, username, endDate, allowContact, buyerMessage = '', clickContact }) => {
    const sellerName = displayName || username;

    return (
        <Banner title={<I18n k="out_of_office.banner.buyer.seller_is_out" params={{ sellerName, date: getDateStringFromTimestamp(endDate) }}/>}
            text={buyerMessage ? <i>“{buyerMessage}”</i> : null}>
            {allowContact && (
                <p className="m-t-16 co-grey-1100">
                    <I18n k="out_of_office.banner.buyer.you_can_contact_seller" templates={{
                        contact: (text) => <a className={classNames('text-semi-bold co-grey-1100', classes.link)} href={`/conversations/${username}`} onClick={clickContact}>{text}</a>
                    }}/>
                </p>
            )}
        </Banner>
    );
};

Buyer.propTypes = {
    endDate: PropTypes.number,
    displayName: PropTypes.string,
    username: PropTypes.string,
    allowContact: PropTypes.bool,
    buyerMessage: PropTypes.string,
    clickContact: PropTypes.func
};

export default Buyer;
